import { render, staticRenderFns } from "./PTUserElement.vue?vue&type=template&id=e917bae2"
import script from "./PTUserElement.vue?vue&type=script&lang=js"
export * from "./PTUserElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports